export const ROLES = {
  USER: 'user',
  EDITOR: 'editor',
  REVIEWER: 'reviewer',
  TENANT_ADMIN: 'tenant_admin',
  PORTAL_ADMIN: 'portal_admin',
  AUDITOR: 'auditor',
  GUEST: 'guest',
};

export const PERMISSION_MAP = {
  TENANT_MENU: [ROLES.PORTAL_ADMIN],
  ADMIN_AREA: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.PORTAL_ADMIN,
    ROLES.TENANT_ADMIN,
  ],
  IMPORT_CONTENT: [ROLES.PORTAL_ADMIN],
  EDIT_PAGE: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.PORTAL_ADMIN,
    ROLES.TENANT_ADMIN,
  ],
  FOLLOW: [
    ROLES.USER,
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.PORTAL_ADMIN,
    ROLES.TENANT_ADMIN,
  ],
  DOC_LIBRARY_ADD_FOLDER: [
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  DOC_LIBRARY_DELETE_FOLDER: [
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  DOC_LIBRARY_DELETE_FILE: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  DOC_LIBRARY_UPLOAD_FILE: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  DOC_LIBRARY_MOVE_FILE: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  DOC_LIBRARY_MOVE_FOLDER: [
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  FORUM_CREATE_THREAD: [
    ROLES.USER,
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  FORUM_CREATE_POST: [
    ROLES.USER,
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  FORUM_DELETE_THREAD: [
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  FORUM: [
    ROLES.USER,
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
  ADMIN_PORTAL_SETTINGS: [ROLES.TENANT_ADMIN, ROLES.PORTAL_ADMIN],
  CREATE_CONTENT_CATEGORY: [ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN],
  DELETE_CONTENT_CATEGORY: [ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN],
  DELETE_MASTER_DATA: [ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN, ROLES.REVIEWER],
  ADMIN_GROUPS: [ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN],
  ADMIN_USERS: [ROLES.REVIEWER, ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN],
  ADMIN_USERS_CREATE_USER: [ROLES.TENANT_ADMIN, ROLES.PORTAL_ADMIN],
  ADMIN_ROLES: [ROLES.REVIEWER, ROLES.PORTAL_ADMIN, ROLES.TENANT_ADMIN],
  REVIEW_MASTER_DATA: [ROLES.REVIEWER, ROLES.TENANT_ADMIN, ROLES.PORTAL_ADMIN],
  EXPORT_TO_WORD: [ROLES.PORTAL_ADMIN],
};

const STANDARD_FUNCTIONS_PERMISSIONS = {
  'MENU.FORUM': [
    ROLES.USER,
    ROLES.EDITOR,
    ROLES.REVIEWER,
    ROLES.TENANT_ADMIN,
    ROLES.PORTAL_ADMIN,
  ],
};

export const applyNavigationPermissions = (navItems, user) => {
  const userRoles = user['https://dap.covis.de'].roles;
  return navItems.filter(i => {
    if (i.type === 'standard_function') {
      const permissions = STANDARD_FUNCTIONS_PERMISSIONS[i.value];
      if (permissions) {
        return userRoles.some(r => permissions.includes(r));
      }
    }
    return true;
  });
};

export const hasAccess = (permission, user) => {
  const userRoles = user['https://dap.covis.de'].roles;
  const access = PERMISSION_MAP[permission];
  if (access && userRoles.some(r => access.includes(r))) {
    return true;
  }
  return false;
};

export const hasRole = (user, role) => {
  const userRoles = user['https://dap.covis.de'].roles;
  return userRoles.includes(role);
};

export const hasRoles = (user, roles) => {
  const userRoles = user['https://dap.covis.de'].roles;
  return userRoles.some(r => roles.includes(r));
};
